import {
  LOAD_ONESTEP_REGISTER,
  SUCCESS_ONESTEP_REGISTER,
  ERROR_ONESTEP_REGISTER,
  ACTION_ONESTEP_REGISTER,
  FORCE_STOPLOAD_ONESTEP_REGISTER
} from '../types/oneStepTypes';

const INITIAL_STATE = {
  isLoading: false,
  isActionUser: false,
  error: null,
  data: {
    idTrx: '',
    message: '',
    flgDataVeh: undefined,
  },
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOAD_ONESTEP_REGISTER:
      return {
        ...state,
        ...INITIAL_STATE,
        isLoading: true,
      };
    case SUCCESS_ONESTEP_REGISTER:
      return {
        ...state,
        error: null,
        data: {
          idTrx: action.payload.idTrx,
          message: action.payload.message,
          flgDataVeh: action.payload.flgDataVeh,
        },
        isLoading: false,
      };
    case ERROR_ONESTEP_REGISTER:
      return {
        ...state,
        error: action.payload,
        data: {
          idTrx: '',
          message: '',
          flgDataVeh: false,
        },
        isLoading: false,
      };
    case ACTION_ONESTEP_REGISTER:
      return {
        ...state,
        isActionUser: true,
      };
    case FORCE_STOPLOAD_ONESTEP_REGISTER: {
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          flgDataVeh: true
        }
      };
    }
    default:
      return state;
  }
};

export default reducer;
